export { CourseSearchPageWithCourseSearchProvider as default } from '@web/modules/CourseSearch'
